import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

export interface ILedger {
    _id: string;
    ledgerName: string;
    accountingCode: string;
    groupCategory: {
        _id: string;
        name: string;
        accountingCode: string;
    };
    primaryGroup: {
        _id: string;
        name: string;
        accountingCode: string;
    };
    subGroup?: {
        _id: string;
        name: string;
        accountingCode: string;
    } | null;
}

export interface IChargeLedgersResponse {
    success: boolean;
    count: number;
    type: string;
    ledgers: ILedger[];
}

/**
 * Fetch ledgers for additional charges
 * @param type - 'income' for sales invoices, 'expense' for purchase invoices
 */
export const fetchChargeLedgers = createAsyncThunk(
    'ledger/fetchChargeLedgers',
    async (type: 'income' | 'expense'): Promise<ILedger[]> => {
        const response = await axios.get<IChargeLedgersResponse>(`/api/v1/ledgers/charge-ledgers?type=${type}`);
        return response.data.ledgers;
    }
);

/**
 * Fetch all ledgers
 */
export const fetchLedger = createAsyncThunk(
    'ledger/fetchLedger',
    async (): Promise<ILedger[]> => {
        const response = await axios.get<IChargeLedgersResponse>(`/api/v1/ledgers`);
        return response.data.ledgers;
    }
);

/**
 * Fetch all ledgers for an account from COA (for document settings)
 */
export const fetchAllLedgers = createAsyncThunk(
    'ledger/fetchAllLedgers',
    async (): Promise<ILedger[]> => {
        const response = await axios.get(`/api/v1/coa/ledgers`);
        return response.data.data || [];
    }
);
